"use client";
import React, { useEffect, useMemo, useState } from "react";

import {
  HeaderContainer,
  LogoTitle,
  Logo,
  MenuButton,
  MenuButtonLine1,
  MenuButtonLine3,
  MenuButtonLine2,
  MenuButtonLabel,
  Nav,
  StyledHeader,
  StyledLanguageBar,
  NavLeft,
  NavRight, ContactButton
} from "./styles";

import { headerProps } from "./types";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { PAGES } from "@/config/routes";
import Image from "next/image";
import { Icons } from "@itchannelplus/assets/icons";

import { useLocale } from "next-intl";
import { locales } from "@/config/i18n";
import { ButtonLink } from "@itchannelplus/ui/components/buttons/Button";
import { Content } from "@/layouts/PageLayout/styles";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { Page } from "@/payload-types";

export const Header = ({
  thin,
  disableShadow,
  isMenuOpened,
  toggleMenu,
  logoTitle,
  announcement,
  config,
}: headerProps) => {
  const t = useTranslations();
  const locale = useLocale();
  const languages = locales.map((lang) => ({
    label: lang.toUpperCase(),
    locale: lang,
  }));
  const [small, setSmall] = useState(false);

  const [showContactModal, setShowContactModal] = useState(false);
  const _thin = small || thin;
  //console.log("config", config);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const onScroll = () => setSmall(window.scrollY > 130);
      window.addEventListener("scroll", onScroll);
      onScroll();
      return () => window.removeEventListener("scroll", onScroll);
    }
    return () => {};
  }, []);
  //console.log("===> config header ===>", config.contactPage, config);
  return (
    <>
      <StyledHeader
        thin={_thin}
        disableShadow={disableShadow}
        isMenuOpened={isMenuOpened}
        //style={{ zIndex: isMenuOpened ? 1003 : 100 }}
      >
        {announcement && (
          <AnnouncementBar
            content={announcement.content}
            link={announcement.link}
          />
        )}
        <HeaderContainer>
          <Link href={PAGES.HOME}>
            <Logo thin={_thin} color={"white"}>
              {logoTitle && <LogoTitle>{logoTitle}</LogoTitle>}
            </Logo>
          </Link>
          <Nav>
            <NavLeft>
              <ContactButton
                variant={"outline"}
                color={"light"}
                href={ `/${(config.contactPage as Page)?.slug}` }
                size={"small"}
              >
                {t("common.contact")}
              </ContactButton>
            </NavLeft>
            <NavRight>
              <StyledLanguageBar
                hide={"below-tablet"}
                languages={languages}
                activeLocale={locale}
              />
              <MenuButton onClick={toggleMenu} isMenuOpened={isMenuOpened}>
                <MenuButtonLine1 />
                <MenuButtonLine2 />
                <MenuButtonLine3 />
                <MenuButtonLabel>
                  {isMenuOpened ? t("common.close") : t("header.menu")}
                </MenuButtonLabel>
              </MenuButton>
            </NavRight>
          </Nav>
        </HeaderContainer>
        <StyledLanguageBar
          hide={"over-tablet"}
          languages={languages}
          activeLocale={locale}
        />
      </StyledHeader>
    </>
  );
};
